import React from 'react';
import {Dropdown} from '../styles';
import {Space, Avatar} from 'antd';
import PageOverlayComercial from "./PageOverlayComercial";
import {DownCircleOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
const PageMenuComercial: React.FC = () => {
  return (
    <Dropdown
      overlay={(
        <PageOverlayComercial
        />
      )}
    >
      <Space>
        <MenuUnfoldOutlined style={{color:'black', fontSize:'20px'}}/>
      </Space>
    </Dropdown>
  );
};

export default PageMenuComercial;
